import { useGetDataSourceEnumQuery } from '../services/dataSource'

export function useManageDataSourceOptions() {
  const { data: dataSourceOptions, isLoading: loadingDataSource } = useGetDataSourceEnumQuery()

  return {
    dataSourceOptions,
    loadingDataSource
  }
}
